import { render, staticRenderFns } from "./formLine.vue?vue&type=template&id=4b2cdb84&scoped=true"
import script from "./formLine.vue?vue&type=script&lang=js"
export * from "./formLine.vue?vue&type=script&lang=js"
import style0 from "./formLine.vue?vue&type=style&index=0&id=4b2cdb84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cdb84",
  null
  
)

export default component.exports